module.exports = __webpack_public_path__ + "/img/Dfn3-Custom-Footprint-lyIJvq.svg";